import { render, staticRenderFns } from "./SingleCardLayout.vue?vue&type=template&id=740db5c2&"
import script from "./SingleCardLayout.vue?vue&type=script&lang=js&"
export * from "./SingleCardLayout.vue?vue&type=script&lang=js&"
import style0 from "./SingleCardLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports